export enum productTourTypes {
    SET_RUN = 'SET_RUN',
    SET_STEP_INDEX = 'SET_STEP_INDEX',
    SET_STEP = 'SET_STEP',
}
